/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TaskBoardIcon/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import Icon from './Icon/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TaskBoardIcon({
  children,
  viewPath = "/DesignSystem/TaskBoardIcon",
  opacity = "100%",
  width = 56,
  height = 56,
  borderTopLeftRadius,
  borderTopRightRadius,
  borderBottomLeftRadius,
  borderBottomRightRadius,
  iconHeight,
  iconWidth
  
}) {
let iconBackgroundValueData = fromData.useDataValue({ viewPath,
context: 'icon',
path: 'background',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let borderTopLeftRadiusOrdtSpaceXs = borderTopLeftRadius ?? dtSpaceXs
let borderTopRightRadiusOrdtSpaceXs = borderTopRightRadius ?? dtSpaceXs
let borderBottomLeftRadiusOrdtSpaceXs = borderBottomLeftRadius ?? dtSpaceXs
let borderBottomRightRadiusOrdtSpaceXs = borderBottomRightRadius ?? dtSpaceXs
  return (<React.Fragment
>
<div
  data-testid="TaskBoardIcon.Vertical"
  data-view-path={viewPath}
 style={{'--o-1-1jtBzR': opacity,'--w-2-1jtBzR': typeof width === 'number' ? `${width}px` : width,'--h-3-1jtBzR': typeof height === 'number' ? `${height}px` : height,'--btlr-4-1jtBzR': typeof borderTopLeftRadiusOrdtSpaceXs === 'number' ? `${borderTopLeftRadiusOrdtSpaceXs}px` : borderTopLeftRadiusOrdtSpaceXs,'--btrr-5-1jtBzR': typeof borderTopRightRadiusOrdtSpaceXs === 'number' ? `${borderTopRightRadiusOrdtSpaceXs}px` : borderTopRightRadiusOrdtSpaceXs,'--bblr-6-1jtBzR': typeof borderBottomLeftRadiusOrdtSpaceXs === 'number' ? `${borderBottomLeftRadiusOrdtSpaceXs}px` : borderBottomLeftRadiusOrdtSpaceXs,'--bbrr-7-1jtBzR': typeof borderBottomRightRadiusOrdtSpaceXs === 'number' ? `${borderBottomRightRadiusOrdtSpaceXs}px` : borderBottomRightRadiusOrdtSpaceXs,'--bc-8-1jtBzR': iconBackgroundValueData}}
 className={`views-block ${styles.Vertical}`}
>
<Icon
  viewPath={`${viewPath}/Icon`}
 height={iconHeight}
 width={iconWidth}
/>
</div>
{children}
</React.Fragment>)
}